import { sessionUser } from 'utility/sessionStorageHelper';

export const payerEntityURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `payersvc/v0/cust/${customerId}/user/${userId}/entity/${endpoint}`;
};

export const payerEntityWorkflowURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `payersvc/v0/cust/${customerId}/user/${userId}/workflow/${endpoint}`;
};

export const customerClassificationURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `payersvc/v0/cust/${customerId}/user/${userId}/${endpoint}`;
};

export const usersURL = endpoint => {
  const { customerId } = sessionUser.getLoggedInUser().getId();
  return `usersvc/v0/users/cust/${customerId}/${endpoint}`;
};

// Explicit set of endpoint constants accepted by getGpxUrl.
// Any value not in this set is silently replaced with '' so that callers
// cannot accidentally forward tainted runtime data into the URL sink.
import { CONCOURSE_CREATE_PAYMENT, CONCOURSE_IRA, UPLOAD_CONCOURSE_ENTITIES } from 'Constants/routes';
const ALLOWED_GPX_ENDPOINTS = new Set(['', CONCOURSE_CREATE_PAYMENT, CONCOURSE_IRA, UPLOAD_CONCOURSE_ENTITIES]);

export const getGpxUrl = endpoint => {
  const user = sessionUser.getLoggedInUser();
  const portalSsoName = user?.portalSsoName ?? '';
  const custWebId = user?.userCustomer?.custWebId ?? '';

  // Allowlist check: reject anything not in the approved set so tainted input
  // can never reach the URL sink even if the caller is bypassed.
  const safeEndpoint = ALLOWED_GPX_ENDPOINTS.has(endpoint) ? endpoint : '';

  try {
    const gpxUrlString = typeof window !== 'undefined' ? window.GPX_URL : '';
    if (!gpxUrlString) {
      console.warn('[getGpxUrl] window.GPX_URL is not configured');
      return '';
    }

    // Use window.location.origin as base to resolve relative URLs like '/gpx'
    // Absolute URLs like 'https://example.com/gpx' are unaffected
    const base = new URL(gpxUrlString, typeof window !== 'undefined' ? window.location.origin : '');

    if (!['http:', 'https:'].includes(base.protocol)) {
      console.warn('[getGpxUrl] GPX_URL protocol must be http: or https:, got:', base.protocol);
      return '';
    }

    if (safeEndpoint) {
      base.pathname = base.pathname.replace(/\/$/, '') + safeEndpoint;
    }

    base.searchParams.set('userId', portalSsoName);
    base.searchParams.set('custWebId', custWebId);
    return base.toString();
  } catch (error) {
    console.error('[getGpxUrl] Failed to construct GPX URL:', error);
    return '';
  }
};
